import HTTP_Client from '@services/support/http-client';
import { NEXT_PUBLIC_BLOG_URL } from '@utils/constants';
import { each } from '@utils/objects';

class Blog_Client extends HTTP_Client {
  constructor() {
    super({
      baseURL: process.env.BLOG_URL || (process.env.NEXT_PUBLIC_BLOG_URL || (NEXT_PUBLIC_BLOG_URL || '')),
    });
  }

  /**
   * @returns import('../payload-types').Post[]
   */
  async getNews(params = {}) {
    const response = await this.get('wp/v2/posts', { ...params, _embed: true, categories: 87 });

    if (! Array.isArray(response)) {
      return [];
    }

    return each(response, (post) => {
      const medias = post?._embedded['wp:featuredmedia'] || [];
      const cover = String(medias[0].source_url) || undefined;

      /**
       * @var {import('../payload-types').Post}
       */
      return {
        id: post.id,
        title: post.title.rendered,
        description: post.excerpt.rendered.replace('[&hellip;]', '&hellip;'),
        status: (post.status === 'publish' ? 'published' : 'draft'),
        cover: (cover ? { url: cover } : undefined),
        link: post.link,
        content: post.content.rendered,
        content_html: post.content.rendered,
      }
    }, true);
  }

  async healthcheck() {
    const response = await this.get();
    return typeof response.name !== 'undefined';
  }
}

export default function getClient() {
  let instance = null;

  if (! instance) {
    instance = new Blog_Client();
  }

  return instance;
}
